/* eslint-disable no-unused-vars */
import React, {
    useRef,
    useMemo,
    useContext,
    useEffect,
} from 'react';
import { Box, Typography, Paper } from '@mui/material';
import useNebula from 'hooks/useNebula';
import PropTypes from 'prop-types';
import { styled } from '@mui/system';
import AppContext from '../AppContext';

const PieWrapper = styled(Box, {})(({ theme }) => ({
    width: '100%',
    height: '100%',
    h3: {
        fontFamily: 'Lora',
        // textTransform: 'Capitalize',
        fontSize: '1em',
        color: theme.palette.green.main,
    },
}));

const Viz = styled(Box)({
    height: 300,
    width: '100%',
});

const Pie = ({ title, options }) => {
    const { qlikApp } = useContext(AppContext);

    const nebula = useNebula();

    const elementRef = useRef();
    const vizRef = useRef();

    useEffect(async () => {
        if (!nebula) return;

        vizRef.current = await nebula.render({
            element: elementRef.current,
            type: 'pie',
            fields: [
                {
                    qDef: {
                        qFieldDefs: [options.dimension],
                    },
                },
                {
                    qDef: {
                        qDef: options.measure,
                        qNumFormat: {
                            qType: 'I',
                            qnDec: 2,
                            qUseThou: 0,
                            qFmt: '###%',
                            qDec: '.',
                        },
                    },

                },
            ],
        });
    }, [nebula]);

    return (
        <PieWrapper>
            <Paper
              elevation={3}
              sx={{
                    width: '100%',
                    height: '100%',
                    padding: '10px',
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '10px',
                }}
            >
                <Typography variant="h3">{title}</Typography>
                <Viz id="pieViz" ref={elementRef} />
            </Paper>
        </PieWrapper>
    );
};

Pie.propTypes = {
    options: PropTypes.object.isRequired,
    title: PropTypes.string,
};

Pie.defaultProps = {
    title: '',
};

export default Pie;
